module.exports = __webpack_public_path__ + "img/example-3.72cbed50.png";